import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43fef4ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-form" }
const _hoisted_2 = { class: "footitem" }
const _hoisted_3 = {
  class: "flex-ter-start",
  style: {"width":"50px"}
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "footitem" }
const _hoisted_6 = { class: "flex-ter-start" }
const _hoisted_7 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { dayjs, ElMessage, FormInstance, ElCheckbox, ElIcon } from 'element-plus'
import { ref, reactive, watch, computed } from 'vue'
import { WarningFilled } from '@element-plus/icons-vue'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()


const checkedNoTips = ref(false)


const form = reactive({
  status: '0'
})

const submit = () => {
  // console.log(form)

  if (checkedNoTips.value) {
    const customerId = store.getters.user?.mainCustomerId

    // 获取已有的customerId数组，如果没有则创建一个空数组
    const existingIdsString = localStorage.getItem('isNotTipsOneClickConfirms')
    const existingIds = existingIdsString ? JSON.parse(existingIdsString) : []

    // 检查customerId是否已存在于数组中
    console.log('11')
    if (!existingIds.includes(customerId)) {
      // 如果不存在则添加到数组中
      existingIds.push(customerId)
      localStorage.setItem('isNotTipsOneClickConfirms', JSON.stringify(existingIds))
    }
  }
  form.status = '0'
  emits('success', form)
  form.status = '1'
  checkedNoTips.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('update:visible', false))),
    draggable: "",
    title: _unref(t)('关闭提醒'),
    "custom-class": "one-click-confirm-dialog"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, [
            _createVNode(_unref(ElCheckbox), {
              modelValue: checkedNoTips.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkedNoTips).value = $event)),
              label: _unref(t)('不再提示')
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('update:visible', false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (submit()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(ElIcon), { class: "icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(WarningFilled))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "flex-ter-end fx-1",
            innerHTML: _unref(t)('关闭后将不再向您店铺同步物流单号及订单状态')
          }, null, 8, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})